import React, { useState } from "react";

const CompaintAccordionItem = ({
	id,
	category,
	subCategory,
	complainId,
	status,
	details,
	time,
	date,
	LinkUrl
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div
			id="accordion"
			className="ui-accordion ui-widget ui-helper-reset"
			role="tablist"
		>
			{/* Header */}
			<h3
				className={`ui-accordion-header ui-corner-top ui-state-default ui-accordion-icons ${isOpen
						? "ui-accordion-header-active ui-state-active"
						: "ui-accordion-header-collapsed ui-corner-all"
					}`}
				role="tab"
				id={`ui-id-${id}`}
				aria-controls={`ui-panel-${id}`}
				aria-selected={isOpen}
				aria-expanded={isOpen}
				tabIndex={0}
				onClick={() => setIsOpen(!isOpen)}
			>
				<span
					className={`ui-accordion-header-icon ui-icon ${isOpen ? "ui-icon-triangle-1-s" : "ui-icon-triangle-1-e"
						}`}
				></span>

				<div className="categorysubcategory">
					<span className="category">{category}</span>
					<span className="subcategory">{subCategory}</span>
				</div>

				<div className="status-tckno">
					<span className="complain-id">Ticket No. {complainId}</span>
					<span className="status" data-text={status}>
						{status}
					</span>
				</div>
			</h3>

			{/* Panel */}
			<div
				className="list-p ui-accordion-content ui-corner-bottom ui-helper-reset ui-widget-content"
				style={{ display: isOpen ? "block" : "none" }}
				id={`ui-panel-${id}`}
				aria-labelledby={`ui-id-${id}`}
				role="tabpanel"
				aria-hidden={!isOpen}
			>
				<div className="description">
					<div className="complaindetails"> <div dangerouslySetInnerHTML={{ __html: details.replaceAll("&lt;br /&gt;","<br/>") }} /></div>
					{/* <div className="complaindetails" > hdkadkas \n jdsjad \n</div> */}
					
					<div className="datetime">
						<span className="complain-time">{time}</span>
						<span className="complain-date">&emsp;{date}</span>
					</div>
				</div>
				{LinkUrl!=="" &&(
				<div className='img-url'>
					<a href={LinkUrl} target='_blank'>
						<img src={LinkUrl} /></a></div>
						)}
			</div>
		</div>
	);
};

export default CompaintAccordionItem;
